export default __webpack_public_path__ + "static/media/Ms.Kaitlin_Mitchell.3dffa63a.png";